import React, { Component } from 'react'
import { ButtonSecondary } from '../components/Buttons'
import './RowEdit.css'

class RowEdit extends Component {
  constructor (props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }
  handleClick (ev) {
    ev.preventDefault()
    this.props.history.push('/edit/' + this.props.id)
  }
  render () {
    return (
      <div className='row_edit'>
        <div className='row_edit__data'>
          <h4 className='row_edit__title'>{this.props.titulo}</h4>
          <p className='row_edit__meta'>
            {this.props.active ? <span className='active'>Activa</span> : <span>Finalizada</span>}
          </p>
        </div>
        <div className='row_edit__actions'>
          <ButtonSecondary
            label='Administrar'
            onClick={this.handleClick}
            sm
          />
        </div>
      </div>
    )
  }
}

export default RowEdit
